import React from 'react';
export function SeoBar() {
  return <div className="bg-gray-100 border-b border-gray-200" data-id="element-210">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2" data-id="element-211">
        <p className="text-xs sm:text-sm text-navy text-center leading-relaxed" data-id="element-212">
          Peak Machine Sales is Michigan's trusted source for new and used CNC
          machine tools—Wire & Sinker EDM, CNC machining centers, laser,
          automation, and service since 1995.
        </p>
      </div>
    </div>;
}